import { useNavigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box } from '@mui/material';
import { Link } from '@mui/icons-material';

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

export default function SubscriptionDenied() {
  const navigate = useNavigate();
  return (
    <ContentStyle sx={{ textAlign: 'center', alignItems: 'center' }}>
      <Typography variant="h3" paragraph>
        Complete your subscription plan
      </Typography>

      <Typography sx={{ color: 'text.secondary' }}>

        You have not selected a subscription plan yet. Please choose one of our plans and subscribe to gain full access to our system.
      </Typography>

      <Button startIcon={<Link />} sx={{ marginTop: 2 }} size="large" variant="contained" onClick={() => navigate('/admin/subscription')}>
        Go to  subscription plan
      </Button>
    </ContentStyle>
  );
}
